import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 46 53"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "m16.78 3.302 22.592 13.293V43.22l5.637-3.325V13.293L22.416 0z" }, null, -1),
    _createElementVNode("path", { d: "m8.528 8.172 22.493 13.222v26.744l5.63-3.318V18.203L14.026 4.925z" }, null, -1),
    _createElementVNode("path", { d: "m.162 13.105 22.585 13.293L22.754 53l5.537-3.231v-26.72L5.798 9.78z" }, null, -1),
    _createElementVNode("path", { d: "M2.276 41.158 20.293 51.76V30.547zM0 15.912v23.7l5.637-3.317V19.23zM2.215 2.697h.83c.377 0 .63-.235.63-.604 0-.36-.253-.604-.63-.604h-.83zM3.737 4.62l-.923-1.585h-.6V4.62h-.338V1.152h1.17c.668 0 .968.463.968.941 0 .447-.254.863-.815.926l.93 1.592h-.392zM.338 2.885C.338 1.497 1.446.368 2.822.368c1.384 0 2.492 1.137 2.492 2.517 0 1.389-1.108 2.518-2.492 2.518-1.376 0-2.484-1.137-2.484-2.518m-.338 0C0 4.462 1.261 5.74 2.822 5.74s2.822-1.278 2.822-2.855S4.384.031 2.822.031C1.262.03 0 1.309 0 2.885" }, null, -1)
  ])))
}
export default { render: render }